// Shared helpers for rendering a practitioner's enabled / kyc status and gating the
// enable/disable control across the support practitioner-management surfaces (listing rows,
// profile drawer, detail page, access-log views).

// Effective "live" state — mirrors the logic the profile drawer already uses: a practitioner
// counts as disabled when enabled is explicitly false OR services.live is explicitly false.
export function derivePractitionerEnabled(practitioner) {
  if (!practitioner) return true
  if (practitioner.enabled === false) return false
  if (practitioner.services?.live === false) return false
  return true
}

export const KYC_STATUS_META = {
  approved: { label: 'KYC Approved', color: 'success' },
  pending: { label: 'KYC Pending', color: 'warning' },
  rejected: { label: 'KYC Rejected', color: 'error' },
}

export function getKycStatusMeta(kycStatus) {
  if (!kycStatus) return null
  const key = String(kycStatus).toLowerCase()
  return KYC_STATUS_META[key] || { label: `KYC: ${kycStatus}`, color: 'default' }
}

// Mirrors the support practitioner-onboarding controller's @PreAuthorize and the existing
// enable-button gating in SupportMentorsListing: ROLE_ADMIN everywhere, ROLE_THERAPIST_ADMIN
// for therapist/screener contexts, ROLE_CLINIC_SUCCESS_ADMIN for the doctor context.
export function canManagePractitionerEnabledState(allRolesInBoolean, practitionerType) {
  if (!allRolesInBoolean) return false
  if (allRolesInBoolean.isAdmin) return true
  if (practitionerType === 'doctor') return Boolean(allRolesInBoolean.isClinicSuccessAdmin)
  return Boolean(allRolesInBoolean.isTherapistAdmin)
}

// Backend access-log timestamps arrive as "yyyy-MM-dd HH:mm:ss" in UTC. Render them in the
// viewer's locale / timezone.
export function formatAccessLogTimestamp(value) {
  if (!value) return ''
  const normalized =
    typeof value === 'string' && value.includes(' ') && !value.includes('T')
      ? `${value.replace(' ', 'T')}Z`
      : value
  const date = new Date(normalized)
  if (Number.isNaN(date.getTime())) return String(value)
  return date.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export const PRACTITIONER_TYPE_LABEL = {
  therapist: 'Therapist',
  doctor: 'Doctor',
  screener: 'Screener',
}
